import { h } from 'preact';
import { expect } from 'chai';
import * as MessageUtils from '@oracle/oraclejet-preact/UNSAFE_Message';

describe('Test MessageUtils', () => {
  it('throwError', function () {
    try {
      MessageUtils.throwError('foo');
      expect(true).to.be.false;
    } catch (e) {
      expect(e).not.null;
    }
  });

  it('getRenderer', function () {
    const message = {
      data: {
        detail: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
      },
      index: 0,
      key: 'ConfirmationMessage',
      metadata: { key: 'ConfirmationMessage' }
    };
    const renderers = {
      testRenderer: () => <div></div>
    };

    // don's pass any renderers
    const noRenderers = MessageUtils.getRenderer(message, 'testRenderer');
    expect(noRenderers).undefined;

    // get renderer by valid id
    const rendererByIdValid = MessageUtils.getRenderer(message, 'testRenderer', renderers);
    expect(rendererByIdValid).to.equal(renderers.testRenderer);
    // get renderer by invalid id
    // (this should throw an error, but if not, verify that the renderer is null)
    try {
      const rendererByIdInvalid = MessageUtils.getRenderer(message, 'foo', renderers);
      expect(rendererByIdInvalid).null;
    } catch (e) {
      expect(e).not.null;
    }
    // get renderer by undefined id
    const rendererIdUndefined = MessageUtils.getRenderer(message, undefined, renderers);
    expect(rendererIdUndefined).undefined;

    // get renderer by function that returns a valid id
    const rendererByFuncValid = MessageUtils.getRenderer(message, () => 'testRenderer', renderers);
    expect(rendererByFuncValid).to.equal(renderers.testRenderer);
    // get renderer by function that returns an invalid id
    // (this should throw an error, but if not, verify that the renderer is null)
    try {
      const rendererByFuncInvalid = MessageUtils.getRenderer(message, () => 'foo', renderers);
      expect(rendererByFuncInvalid).null;
    } catch (e) {
      expect(e).not.null;
    }
    // get renderer by function that returns a null id
    const rendererByFuncNull = MessageUtils.getRenderer(message, () => null, renderers);
    expect(rendererByFuncNull).undefined;
  })
});
